export class GetNews {
  static readonly type = "[News] Get news";
}
